import styled from 'styled-components';
import { grid } from '@finect/tabular-utils/grid';
import { getFont } from '@finect/tabular-utils/getFont';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const HowItWorks = styled.div`
  max-width: ${grid(6)}px;
  padding: 0 48px;
  margin-top: 30px;
  text-align: center;

  h3 {
    margin-bottom: 30px;
    ${getFont(3, 'compact')};
    font-weight: 700;
  }

  > div {
    display: inline-block;
    padding: 30px 42px;
    border-radius: ${({ theme }) => theme.borderRadius};
    /* stylelint-disable */
    box-shadow: rgba(34, 34, 90, 0.1) 0 0 35px, rgba(0, 0, 0, 0.07) 0 0 15px, rgba(34, 34, 90, 0.07) 0 1px 3px 1px,
      rgba(34, 34, 90, 0.05) 0 -1px 0 0;
    /* stylelint-enable */
  }

  ol {
    counter-reset: steps;
    text-align: left;
  }

  li {
    max-width: ${grid(4)}px;
    padding: 0;
    margin: 0 auto;

    &:not(:last-child) {
      padding-bottom: 24px;
    }
  }

  ${maxMediaQueries.tablet`
    padding: 0 24px;
    margin-left: auto;
    margin-right: auto;
  `};

  ${maxMediaQueries.phablet`
    > div {
      padding: 30px 24px;
    }
  `};

  ${maxMediaQueries.phone`
    padding: 0 15px;
  `};
`;
